package web.fstech.onthecoffee.auth

import web.fstech.onthecoffee.mvi.UiEffect
import web.fstech.onthecoffee.mvi.UiIntent
import web.fstech.onthecoffee.mvi.UiState

enum class AuthTab(val route: String) {
    SIGN_IN("signin"),
    SIGN_UP("signup"),
    FORGOT_PASSWORD("forgot"),
    DELETE_ACCOUNT("delete");

    companion object {
        fun fromRoute(route: String): AuthTab {
            return entries.find { it.route == route } ?: SIGN_IN
        }
    }
}

data class AuthState(
    val email: String = "",
    val password: String = "",
    val currentTab: AuthTab = AuthTab.SIGN_IN,
    val isLoading: Boolean = false,
    val deleteConfirmed: Boolean = false,
    val statusMessage: String? = null,
    val isSuccess: Boolean = false
) : UiState

sealed interface AuthIntent : UiIntent {
    data class EmailChanged(val email: String) : AuthIntent
    data class PasswordChanged(val password: String) : AuthIntent
    data class TabChanged(val tab: AuthTab) : AuthIntent
    data class DeleteConfirmedChanged(val confirmed: Boolean) : AuthIntent
    data object SubmitSignIn : AuthIntent
    data object SubmitSignUp : AuthIntent
    data object SubmitForgotPassword : AuthIntent
    data object SubmitDeleteAccount : AuthIntent
    data object ClearStatus : AuthIntent
}

sealed interface AuthEffect : UiEffect {
    data class ShowToast(val message: String) : AuthEffect
    data object NavigateHome : AuthEffect
    data class NavigateToRoute(val route: String) : AuthEffect
}
